var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardinalityManyMany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H28C30.2091 0 32 1.79086 32 4V28C32 30.2091 30.2091 32 28 32H4C1.79086 32 0 30.2091 0 28V4Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16H21.5M18 16V23.5C18 24.6 18.9 25.5 20 25.5H21.5M14 16V23.5C14 24.6 13.1 25.5 12 25.5H10.5M18 16.25V8.75C18 7.65 18.9 6.75 20 6.75H21.5M14 16.25V8.75C14 7.65 13.1 6.75 12 6.75H10.5M26.3 18H22.7C22.04 18 21.5 17.46 21.5 16.8V15.2C21.5 14.54 22.04 14 22.7 14H26.3C26.96 14 27.5 14.54 27.5 15.2V16.8C27.5 17.46 26.96 18 26.3 18ZM5.7 18H9.3C9.96 18 10.5 17.46 10.5 16.8V15.2C10.5 14.54 9.96 14 9.3 14H5.7C5.04 14 4.5 14.54 4.5 15.2V16.8C4.5 17.46 5.04 18 5.7 18ZM26.3 27.5H22.7C22.04 27.5 21.5 26.96 21.5 26.3V24.7C21.5 24.04 22.04 23.5 22.7 23.5H26.3C26.96 23.5 27.5 24.04 27.5 24.7V26.3C27.5 26.96 26.96 27.5 26.3 27.5ZM5.7 27.5H9.3C9.96 27.5 10.5 26.96 10.5 26.3V24.7C10.5 24.04 9.96 23.5 9.3 23.5H5.7C5.04 23.5 4.5 24.04 4.5 24.7V26.3C4.5 26.96 5.04 27.5 5.7 27.5ZM26.3 8.5H22.7C22.04 8.5 21.5 7.95999 21.5 7.29999V5.70001C21.5 5.04001 22.04 4.5 22.7 4.5H26.3C26.96 4.5 27.5 5.04001 27.5 5.70001V7.29999C27.5 7.95999 26.96 8.5 26.3 8.5ZM5.7 8.5H9.3C9.96 8.5 10.5 7.95999 10.5 7.29999V5.70001C10.5 5.04001 9.96 4.5 9.3 4.5H5.7C5.04 4.5 4.5 5.04001 4.5 5.70001V7.29999C4.5 7.95999 5.04 8.5 5.7 8.5Z",
    stroke: "black",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardinalityManyMany);
export default __webpack_public_path__ + "static/media/cardinality-many-many.e69cc6d0663f540a0f55b072ea2ed91b.svg";
export { ForwardRef as ReactComponent };